<label  for="{{childId}}" class="checkbox-container">
    <input [checked]="checked" (change)="changed($event)" id="{{childId}}" type="checkbox" />
    <ng-content></ng-content>
    <span class="checkmark"></span>
</label>